import React from 'react'
import { StyledWardenTitle } from '../components/StyledWardenTitle'
import { StyledWardenParagraph } from '../components/StyledWardenParagraph'
import { StyledWebLinkButton } from '../components/StyledWebLinkButton'
import {
    StyledActionWrapper,
    StyledContainer,
} from './TheNightlyAccountDeleted.styled'

export const AccountDeleted: React.FC = () => {
    return (
        <StyledContainer>
            <StyledWardenTitle>Your account has been deleted</StyledWardenTitle>
            <StyledWardenParagraph>
                Your account with The Nightly has been deleted as requested. If
                you have any concerns, contact us at
                [support@thenightly.com.au].
            </StyledWardenParagraph>
            <StyledActionWrapper>
                <StyledWebLinkButton to="/" forceInternalSSR>
                    BACK TO HOME
                </StyledWebLinkButton>
            </StyledActionWrapper>
        </StyledContainer>
    )
}
